import { useCallback, useEffect } from 'react';
import { type OasisTaskViewModel } from '@generated';
import type { FormikValues } from 'formik';
import { useForm } from '~/shared/forms/FormContext';
import { calculateCollaborationDivergence } from './util';

export function VisitOasisTaskCollaboration({ oasisTask, originalValues }: { oasisTask: OasisTaskViewModel; originalValues: FormikValues }) {
	const { formHelpers } = useForm();
	const values = formHelpers.values;
	const collaborationAnswerDiverged = calculateCollaborationDivergence(oasisTask, originalValues, values);
	const existingCollaborationAnswerDiverged = formHelpers.values.collaborationAnswerDiverged;

	const updateCollaborationAnswers = useCallback(
		(diverged: boolean) => {
			console.log('Updating collabortion answers. Diverged:', diverged);
			formHelpers.setFieldValue('collaborationAnswerDiverged', diverged);
			if (!diverged) {
				formHelpers.setFieldValue('divergenceReason', null);
			}
		},
		[formHelpers]
	);

	useEffect(() => {
		if (collaborationAnswerDiverged !== existingCollaborationAnswerDiverged) {
			updateCollaborationAnswers(collaborationAnswerDiverged);
		}
	}, [collaborationAnswerDiverged, existingCollaborationAnswerDiverged, updateCollaborationAnswers]);

	return null;
}
